export default __webpack_public_path__ + "assets/images/6ad47ec96ded263fe8823ecac981c8b0.png";